import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'react-mdl/extra/material.css';
import 'react-mdl/extra/material.js';
import {HashRouter} from 'react-router-dom';

ReactDOM.render(
    <HashRouter>
    <App />
    </HashRouter>                                       //used HashRouter instead of BrowserRouter that gh-page dont render well. I think reason is url is not suitable for github server as it reverses and no homepages like ./#/ as with hashrouter.
    
    , document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js